import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
const OptInLabel = ()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
                className: "ptw-text ptw-text-body-md ptw-text-surface-text",
                children: [
                    "Yes, I agree to receiving email and other marketing communications from Purina and its",
                    ' ',
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("a", {
                        className: "inline-link ptw-text-surface-text ptw-underline hover:ptw-text-surface-text",
                        target: "_blank",
                        href: "https://www.purina.com/brands",
                        rel: "noreferrer",
                        children: "brands."
                    }),
                    ' ',
                    "I certify that I am over 18 years old and I have read and agree with the",
                    ' ',
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("a", {
                        className: "inline-link ptw-text-surface-text ptw-underline hover:ptw-text-surface-text",
                        target: "_blank",
                        href: "https://www.purina.com/terms-and-conditions",
                        rel: "noreferrer",
                        children: "Terms & Conditions"
                    }),
                    ' ',
                    "and",
                    ' ',
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("a", {
                        className: "inline-link ptw-text-surface-text ptw-underline hover:ptw-text-surface-text",
                        target: "_blank",
                        href: "https://www.purina.com/purina-perks-terms-and-conditions",
                        rel: "noreferrer",
                        children: "Purina Perks Terms and Conditions"
                    }),
                    ".",
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                        className: "ptw-text-surface-text",
                        children: " (Required)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "pds-my-4"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
                className: "pds-text-surface-text",
                children: [
                    "By clicking ",
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                        className: "pds-italic",
                        children: "Submit"
                    }),
                    " you acknowledge you have read our",
                    ' ',
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("a", {
                        className: "inline-link ptw-text-surface-text ptw-underline hover:ptw-text-surface-text",
                        target: "_blank",
                        href: "https://www.purina.com/privacy-policy",
                        rel: "noreferrer",
                        children: "Privacy Policy"
                    }),
                    ', ',
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("a", {
                        className: "inline-link ptw-text-surface-text ptw-underline hover:ptw-text-surface-text",
                        target: "_blank",
                        href: "https://www.purina.com/privacy-policy#notice-at-collection",
                        rel: "noreferrer",
                        children: "Notice at Collection"
                    }),
                    ', ',
                    "and",
                    ' ',
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("a", {
                        className: "inline-link ptw-text-surface-text ptw-underline hover:ptw-text-surface-text",
                        target: "_blank",
                        href: "https://www.purina.com/purina-perks-terms-and-conditions#notice-of-financial-incentive-loyalty-program",
                        rel: "noreferrer",
                        children: "Notice of Financial Incentive/Loyalty Program"
                    }),
                    "."
                ]
            })
        ]
    });
const _components_OptInLabel = OptInLabel;
export { _components_OptInLabel as default };
